var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmailIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.9514 4.5H3.95135C3.55353 4.5 3.172 4.65804 2.89069 4.93934C2.60939 5.22064 2.45135 5.60218 2.45135 6V18C2.45135 18.3978 2.60939 18.7794 2.89069 19.0607C3.172 19.342 3.55353 19.5 3.95135 19.5H21.9514C22.3492 19.5 22.7307 19.342 23.012 19.0607C23.2933 18.7794 23.4514 18.3978 23.4514 18V6C23.4514 5.60218 23.2933 5.22064 23.012 4.93934C22.7307 4.65804 22.3492 4.5 21.9514 4.5ZM20.3014 6L12.9514 11.085L5.60135 6H20.3014ZM3.95135 18V6.6825L12.5239 12.615C12.6494 12.7021 12.7986 12.7488 12.9514 12.7488C13.1042 12.7488 13.2533 12.7021 13.3789 12.615L21.9514 6.6825V18H3.95135Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIcon);
export default __webpack_public_path__ + "static/media/email-icon.71a22b96a5706b98aadbf712facc3a0d.svg";
export { ForwardRef as ReactComponent };